import PrintPreview from "../../Customer/Print Preview/PrintPreview"

const AdminPrintPreview = ({ TabConfig }) => {
  return <PrintPreview TabConfig={TabConfig} />;
};

export default AdminPrintPreview;
